export const tvPrevious = {
  name: "tv-previous" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M2.1 3a.9.9 0 0 1 .9-.9h1a.9.9 0 0 1 .9.9v18a.9.9 0 0 1-.9.9H3a.9.9 0 0 1-.9-.9V3Zm17.85.426a.9.9 0 0 1 .45.78v15.588a.9.9 0 0 1-1.35.78l-13.5-7.795a.9.9 0 0 1 0-1.558l13.5-7.795a.9.9 0 0 1 .9 0Z" clip-rule="evenodd"/></svg>`,
  keywords: ["tv-previous"],
  category: "action" as const,
};
